<template>
  <div class="ccp-container">
    <div id="defaultCCP" ref="containerDiv" style="display:none"></div>
    <titlebar v-if="pageroute != 'login'"> </titlebar>
    <login v-if="pageroute == 'login'"> </login>
    <home v-if="pageroute == 'home'"> </home>
    <call v-if="pageroute == 'call'"> </call>
    <chat v-if="pageroute == 'chat'"> </chat>
    <profile v-if="pageroute == 'profile'"> </profile>
    <!-- <numberpad v-if="pageroute=='numberpad'"></numberpad> -->
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Login from './components/Login'
import Home from './components/Home'
import Call from './components/Call'
import Chat from './components/Chat'
import Titlebar from './components/Titlebar'
import Profile from './components/Profile'
import NumberPad from './components/NumberPad'

import { mapGetters } from 'vuex'
import 'amazon-connect-streams'
import 'amazon-connect-chatjs'
import { onSendMessage, onEndChat, onClearChat } from './lib/ChatActions'
import { makeOutboundCall } from './lib/CallActions'
import Freshsales from './services/FreshsalesApi'
import Axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import store from './store'
Vue.use(Axios)

export default {
  name: 'App',
  components: {
    Login,
    Home,
    Call,
    Chat,
    Titlebar,
    Profile,
  },
  computed: {
    ...mapGetters(['connect_instance', 'region', 'pageroute']),
  },
  created() {
    
    let uri = window.location.search.substring(1)
    let params = new URLSearchParams(uri)
    let details = {}
    details.connect_instance = params.get('instance')
    details.region = params.get('region')
    details.websocket_url = params.get('websocket_url')
    details.connect_alias = details.connect_instance.replace(
      /.+\/\/|www.|\..+/g,
      ''
    )
    this.$store.dispatch('common/setInstanceDetails', details)
  },

  mounted() {
    let _this = this

    localStorage.setItem("isCallConnected",true)
   

    
     
    

  
   

    window.addEventListener(
      'message',
      function(event) {
        if (event.data.action == 'SEND_MESSAGE') {
          onSendMessage(event.data)
        } else if (event.data.action == 'END_CHAT') {
          onEndChat(event.data.data)
        } else if (event.data.action == 'MAKE_OUTBOUND_CALL') {
          makeOutboundCall(event.data.phoneNumber, event.data.phoneNumber)
          console.log('MAKE OUTBOUNDCALL TRIGGERED==========', event.data)
          _this.$store.dispatch('call/updateOnDestroyedFlag', true)
          _this.$store.dispatch('call/updateCallerName', event.data.name)
          _this.$store.dispatch('call/updateCallerNumber',event.data.phoneNumber)
          _this.$store.dispatch('call/updateCallerId', event.data.callerId)

          console.log('OUTBOUND EVENTS========', event.data)
          _this.$store.dispatch('actions/setOutboundCall', true)

          _this.$store.dispatch('call/updateCallerName', event.data.name)
        } else if (event.data.action == 'CLEAR_CHAT') {
          onClearChat(event.data.data)
        } else if (event.data.action == 'CALL_CONTACT_LIST') {
          console.log('CALL_CONTACT_LIST=========', event)
          // _this.$store.dispatch(
          //   'call/setCountryCode',
          //   event.data.countrySelected
          // )
          // _this.$store.dispatch('common/setCallContactDetails', event.data);
          _this.$store.dispatch('common/setContactList',event.data.contactList)
        } else if (event.data.action == 'CREATE_TICKET_STATUS') {
          if (event.data.status == 'SUCCESS') {
            _this.$store.dispatch('ticket/pushTicket', event.data)
            _this.$store.dispatch(
              'ticket/setSelectedTicket',
              event.data.ticketId
            )
            _this.$store.dispatch('ticket/toggleEditor', true)
            _this.$store.dispatch('ticket/toggleTicketButton', false)
            _this.$store.dispatch('ticket/toggleNoteButton', false)
          } else {
            _this.$store.dispatch('ticket/toggleTicketButton', false)
            _this.$store.dispatch('ticket/toggleNoteButton', false)
          }
        } else if (event.data.action == 'CREATE_NOTE_STATUS') {
          if (event.data.status == 'SUCCESS') {
            _this.$store.dispatch('ticket/toggleEditor', false)
            _this.$store.dispatch('ticket/toggleNoteButton', false)
          } else {
            _this.$store.dispatch('ticket/toggleNoteButton', false)
          }
        } else if (event.data.action == 'CREATE_CONTACT_STATUS') {
          if (event.data.status == 'SUCCESS') {
            console.log('THIIS IS CREATE CONTACT EVENT', event.data)
            _this.$store.dispatch(
              'call/updateCallerName',
              event.data.callerName
            )
            _this.$store.dispatch('call/updateLeadScore', event.data.leadScore)
            _this.$store.dispatch(
              'call/updateLoyaltyPoints',
              event.data.rewardPoints
            )
            _this.$store.dispatch(
              'call/updateCallerId',
              event.data.targetableId
            )
          } else {
            // _this.$store.dispatch("actions/homeSubNavigation", "home")
          }
        } else if (event.data.action == 'LANGUAGE_CHANGE') {
          console.log(event.data)
          _this.$store.dispatch('actions/setTranslationLang', event.data.data)
        } else if(event.data.action == 'CONTACT_ATTRIBUTES'){
          console.log("CONTACT_ATTRIBUTES",event.data)
          _this.$store.dispatch("call/setFreshChatContactAttributes",event.data);
        } else if(event.data.action == 'CONVERSATION_CREATED'){
          console.log("CONVERSATION CREATED",event.data)
          _this.$store.dispatch('call/setFreshChatConversationId',event.data.conversation_id);
          // _this.$store.dispatch('call/setFreshChatChannelId',event.data.channel_id);
          // _this.$store.dispatch('call/setFreshchatUserId',event.data.user_id);
          _this.$store.dispatch('call/setFreshChatAgentId',event.data.assigned_agent_id);
          _this.$store.dispatch('call/setFreshChatConversationAppId',event.data.app_id);
          // _this.$store.dispatch('call/setFreshChatChannelId',event.data.channel_id);    //newly Added channel id


        }else if(event.data.action == 'LOGGED_IN_USER'){
          console.log("THIS IS LOGGEDIN USER",event.data)
          _this.$store.dispatch('call/setFreshchatOrgAgentId',event.data.agentId);
          _this.$store.dispatch('call/setFreshchatOrgAgentName',event.data.agentName);
          _this.$store.dispatch('call/setFreshChatChannelId',event.data.amazonConnectChannelId);     //newly Added channel id

        }else if(event.data.action == "FRESHCHAT_AGENT_ID"){
          console.log("FRESHCHAT_AGENT_ID FROM app.vue",event.data);
        }else if(event.data.action == "FCRM_CONTACT_DETAILS"){
          console.log("FCRM_CONTACT_DETAILS",event.data);
      
          _this.$store.dispatch('call/setFreshworksCrmContactDetails',event.data);

        }else if(event.data.action == "FCRM_CONTACT_CREATED"){
          console.log("FCRM_CONTACT_CREATED",event.data);

          _this.$store.dispatch('call/setFreshworksCrmContactDetails',event.data);

        }else if(event.data.action == "UPDATE_CALL_LOG"){
          _this.$store.dispatch('common/updateCallLogs',event.data.callLogs)
        }else if(event.data.action == "RECENT_CALL_LOGS"){
          console.log("RECENT_CALL_LOGS",event.data.recentCalls)
          _this.$store.dispatch('common/updateCallLogs',event.data.recentCalls)
        }
      },
      false
    )

    let loginUrl = this.connect_instance
    // let loginUrl = 'https://sandeza-testing.my.connect.aws/ccp-v2#'
    console.log("THIS IS LOGIN URL",loginUrl)

    connect.core.initCCP(defaultCCP, {
      ccpUrl: loginUrl,
      loginPopup: false,
      loginPopupAutoClose: false,
      region: this.region,
      softphone: {
        allowFramedSoftphone: true,
      }
    })

    connect.agent(function(agent) {
      let passData = {}
      passData.action = 'AGENT_CONNECTED'
      passData.agentId = agent.getConfiguration().username
      parent.postMessage(passData, '*')
    })

    var eventBus = connect.core.getEventBus();
    eventBus.subscribe(connect.EventType.TERMINATED, () => {
        console.log('Logged out');
  // Do stuff...
  });

    eventBus.subscribe(connect.AgentEvents.INIT, function() {
      _this.$store.dispatch('common/routePage', 'home')
    })

    connect.agent((agent)=>{
      agent.onRefresh((refresh)=>{
        console.log("On AGENT REFRESH",refresh)
      
      })

      agent.getConfiguration((data)=>{
        console.log("AGENT CONFIGURATIONS",data)
      })

      
      
      

      

      agent.onAfterCallWork((acw)=>{
        console.log("AGENT IS IN ACW STATE",acw)
      })
    })
  },
}
</script>

<style>
@import './assets/common.css';

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif !important; */
  font-family: 'Poppins', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#defaultCCP {
  width: 400px;
  height: 530px;
  overflow: hidden;
}
</style>
